import { Component, OnInit } from '@angular/core';
import { GlobalGuideService } from '../../global-guide.service';

@Component({
  selector: 'country-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss']
})
export class CountryOverlayComponent implements OnInit {

  constructor(public service: GlobalGuideService) {
  }

  ngOnInit() {
  }

}
